<template>
<div :style="columnMargin" @click="toFlashList" class="flash-sale position-relative">
  <img v-if="item.bgImg" class="ajax-cover-bg" :src="item.bgImg" />
  <img v-else class="ajax-cover-bg" src='/clientmodule/distVueCli/newHomeVue/img/flash_bg_new.png' />
  <div class="title">
    <div class="flash_text_icon"></div>
    <van-count-down :time="flashInfo.time" format="DD:HH:mm:ss">
      <template #default="timeData">
        <div v-show="timeData.days > 0" class="flash_time_day">{{timeData.days}}<span class="font_size_10">天</span></div>
        <!-- <div v-show="timeData.days > 0" class="colon">天</div> -->
        <div class="block">{{ timeData.hours > 9 ? timeData.hours : '0' + Number(timeData.hours) }}</div>
        <div class="colon">:</div>
        <div class="block">{{ timeData.minutes > 9 ? timeData.minutes : '0' + Number(timeData.minutes) }}</div>
        <div class="colon">:</div>
        <div class="block">{{ timeData.seconds > 9 ? timeData.seconds : '0' + Number(timeData.seconds) }}</div>
      </template>
    </van-count-down>
  </div>
  <div class="flash-content">
    <div :class="['prod-area',{'scale-10': transform10}]" class="prod-area" v-for="(flashItem, flashKey) in flashInfo.showList[flashIndex]" :key="flashKey" @click.stop="toProdFlashList(flashItem)">
      <img class="prod-img" :src="flashItem.imgUrl" alt="">
      <div v-if="parseInt(Number(flashItem.prodPrice)-Number(flashItem.flashPrice)) >= 1" class="cut-price-bar cut-price">立省{{parseInt(Number(flashItem.prodPrice)-Number(flashItem.flashPrice))}}元</div>
      <div v-else class="cut-price-bar"></div>
      <div class="price"><span class="small-rmb">¥</span>{{flashItem.flashPrice}}</div>
      <!-- <div class="old-price">¥{{flashItem.prodPrice}}</div> -->
    </div>
  </div>
</div>
</template>

<script>
import { CountDown } from 'vant';
import axios from 'axios';
export default { 
  name: 'FlashSale',
  data() {
    return {
      timeDown: 23 * 60 * 60 * 1000,
      transform10: true,
      flashIndex: 0
    }
  },
  props: {
    item: Object,
  },
  components: {
    [CountDown.name]: CountDown,
  },
  created() {
    this.item.flashInfo.time = this.item.flashInfo.downTime
  },
  mounted(){
    setInterval(() => {
      if(this.flashInfo.prodList.length < 8){
        return
      }
      this.transform10 = false
      this.flashIndex = this.flashIndex == 1 ? 0 : 1
      setTimeout(() => {
        this.transform10 = true
      }, 100);
    }, 5000);
  },
  watch: {
  
  },
  computed: {
    prodCategoryId: function(){
      return this.$store.state.home.prodCategoryId
    },
    flashInfo: function(){
      return this.item.flashInfo
    },
    columnMargin(){
      var obj = {}
      if(this.item.marginObj){
        obj={
          'margin-top': this.item.marginObj.top,
          'margin-bottom': this.item.marginObj.bottom
        }
      }
			return obj
    }
  },
  methods: {
    toProdDetail(obj){
      var self = this
      var url = '/client/cpd_' + obj.prodId + '.jhtml'
      this.$store.commit('doTrack',{
        href: url,
        columnDefineId: self.item.columnDefineId,
        ccId: obj.pid,
        adId: obj.prodId,
        adName: obj.prodName,
        idType: 'prodId'
      });
      window.location.href = url
    },
    toProdFlashList(obj){
      var self = this
      var url = this.flashInfo.hrefUrl || '/client/client_1_1_1.jhtml'
      var urlParam = url.indexOf('?') > -1 ? '&' : '?'
      url = url + urlParam + 'ccid=' + this.prodCategoryId + urlParam + 'pid=' + obj.pid
      this.$store.commit('doTrack',{
        href: url,
        columnDefineId: self.item.columnDefineId,
        ccId: '',
        adId: 'xianshiqianggou',
        adName: self.flashInfo.trackInfo.columnName,
        idType: 'btnId'
      });
      window.location.href = url
    },
    toFlashList(){
      var self = this
      var url = this.flashInfo.hrefUrl || '/client/client_1_1_1.jhtml';
      var urlParam = url.indexOf('?') > -1 ? '&' : '?'
      url = url + urlParam + 'ccid=' + this.prodCategoryId
      this.$store.commit('doTrack',{
        href: url,
        columnDefineId: self.item.columnDefineId,
        ccId: '',
        adId: 'xianshiqianggou',
        adName: self.flashInfo.trackInfo.columnName,
        idType: 'btnId'
      });
      window.location.href = url
    }
  }
}
</script>

<style scoped>
.flash-sale{
  width: 345px;
  height: 156px;
  /* background: url(./assets/flash_sale_bg.png) no-repeat;
  background-size: 100%; */
  margin: 10px 15px 0;
  font-size: 15px;
  color: #fff;
}
.title{
  height: 29px;
  display: flex;
  align-items: center;
}
.margin-0-10{
  margin: 0 10px;
}
.flash_text_icon{
  margin: 0 4px 0 10px;
  width: 62px;
  height: 15px;
  background: url(/clientmodule/distVueCli/newHomeVue/img/flash_text_icon.png) no-repeat;
  background-size: 100% 100%
}
.block{
  width: 16px;
  height: 16px;
  background: #FFFBFC;
  border-radius: 2px;
  color: #F72D17;
  font-size: 11px;
  text-align: center;
  line-height: 16px;
}
.font_size_10{
  font-size: 10px
}
.flash_time_day{
  min-width: 23px;
  height: 16px;
  background: #FFFBFC;
  border-radius: 2px;
  color: #F72D17;
  font-size: 11px;
  text-align: center;
  line-height: 16px;
  margin-right: 4px;
  padding: 0 1px;
}
.colon{
  height: 16px;
  line-height: 14px;
  color: #FFFFFF;
  margin: 0 1px;
}
.flash-content{
  width: 325px;
  margin-top: 10px;
  margin-left: 10px;
  display: flex;
  overflow: hidden;
}
.prod-area{
  transform: scale(0.3);
  margin-left: 7px
}
.prod-area:first-child
{
  margin-left: 0
}
.prod-img{
  width: 76px;
  height: 76px;
  display: block;
  object-fit: contain;
  border-radius: 8px;
}
.cut-price-bar{
  width: 66.25px;
  height: 20px;
  transform: scale(0.8);
  margin-top: -10px;
}
.cut-price{
  background-image: linear-gradient(90deg, #FF925F 0%, #FF5601 100%);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 4.875px;
  font-size: 12.5px;
}
.price{
  color: #F72D17;
  font-size: 15px;
  margin-top: 3px;
  text-align: center;
}
.old-price{
  color: #999;
  font-size: 12px;
  margin-top: 3px;
  text-align: center;
  text-decoration: line-through;
}
.small-rmb{
  font-size: 10px;
}
.scale-10{
  transition: all 1s;
  transform: scale(1);
}
</style>